import React, { Component } from 'react';
import propTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';
import cn from 'classnames';

import ComingSoon from '~/Components/Global/Assets/Svgs/ComingSoon';
import Favorite from '~/Components/Global/Assets/Svgs/Favorite';
import Search from '~/Components/Global/Assets/Svgs/Search';
import StickerUploadIcon from '~/Components/Global/Assets/Svgs/StickerUploadIcon';
import NoScrollBar from '~/Components/Global/NoScrollBar/NoScrollBar';
import StickerDrag from '~/Components/Global/Stickers/StickerDrag';
import Product from '~/Components/Global/Stripe/Product';
import { STICKER_PACKS } from '~/Config/Products';
import { dragAndDropSupported } from '~/Context/Global';
import { STICKERS_SEARCH } from '~/Redux/Modules/StickerPacksUi';
import history from '~/Providers/History';

import AppFeatureView, { CUSTOM_STICKERS } from '../AppFeatureView';
import CustomStickers from './CustomStickers';
import FrequentStickers from './FrequentStickers';
import SearchStickers from './SearchStickers';
import RecentStickers from './RecentStickers';

import './Stickers.scss';

const STICKERS_RECENT = 'STICKERS_RECENT';
const STICKERS_FREQUENT = 'STICKERS_FREQUENT';
const STICKERS_CUSTOM = 'STICKERS_CUSTOM';

class Stickers extends Component {
  constructor() {
    super();
    this.state = {
      dndSupported: dragAndDropSupported(),
    };
  }

  componentDidMount = () => {
    this.props.getStickerPacks();
  };

  renderStickerPacks = packs => {
    const { setActivePack, activePack } = this.props;

    return (
      <div className="sticker-packs-sidebar">
        <NoScrollBar showScrollOnHover>
          <span className="title">Packs</span>

          <div
            className="search-stickers"
            role="button"
            tabIndex="0"
            onClick={() => setActivePack(STICKERS_SEARCH)}
          >
            <Search />
          </div>

          <div
            className={cn('recent-stickers', { active: activePack === STICKERS_RECENT })}
            role="button"
            tabIndex="0"
            onClick={() => setActivePack(STICKERS_RECENT)}
          >
            <ComingSoon title="Recent" />
          </div>

          <div
            className={cn('frequent-stickers', { active: activePack === STICKERS_FREQUENT })}
            role="button"
            tabIndex="0"
            onClick={() => setActivePack(STICKERS_FREQUENT)}
          >
            <Favorite title="Frequent" />
          </div>

          <AppFeatureView featureName={CUSTOM_STICKERS}>
            <div
              className={cn('custom-stickers', { active: activePack === STICKERS_CUSTOM })}
              role="button"
              tabIndex="0"
              onClick={() => setActivePack(STICKERS_CUSTOM)}
            >
              <StickerUploadIcon title="Upload" />
            </div>
          </AppFeatureView>

          {packs.map((pack, index) => {
            return [
              <img
                className={cn({ active: activePack === pack.id })}
                key={`i${index}`}
                onClick={() => setActivePack(pack.id)}
                src={pack.stickers[0].url}
                draggable="false"
                onDragStart={e => e.preventDefault()}
              />,
              <div className="spacer" key={`s${index}`} />,
            ];
          })}
        </NoScrollBar>
      </div>
    );
  };

  renderStickerList = packs => {
    const { activePack } = this.props;

    if (activePack === STICKERS_RECENT) {
      return <RecentStickers />;
    }

    if (activePack == STICKERS_FREQUENT) {
      return <FrequentStickers />;
    }

    if (activePack == STICKERS_CUSTOM) {
      return <CustomStickers />;
    }

    return (
      <div className="sticker-packs">
        <NoScrollBar showScrollOnHover>
          {packs
            .filter(p => p.id === activePack)
            .map((pack, index) => {
              return (
                <div key={index} className={cn('sticker-pack', { active: activePack === pack.id })}>
                  <Product product={pack.product} description={pack.name} type={STICKER_PACKS} />
                  {pack.stickers.map(sticker => {
                    return pack.user_id || pack.product.purchased ? (
                      <StickerDrag showDelete={false} sticker={sticker} key={sticker.id} />
                    ) : (
                      <img className="sticker not-purchased" src={sticker.url} />
                    );
                  })}
                </div>
              );
            })}
        </NoScrollBar>
      </div>
    );
  };

  closeSearch = () => {
    const { setActivePack } = this.props;
    setActivePack(null);
  };

  render() {
    const { tabOpen, packs, activePack } = this.props;
    const packsToDisplay = packs.filter(pack => pack.user_id == null); // Removes user's custom pack
    const isList = history.location.pathname.startsWith('/lists');

    if (!tabOpen || isList) return false;

    if (activePack == STICKERS_SEARCH) {
      return (
        <div className="user-stickers-packs">
          <div className="flex-row">
            <SearchStickers onClose={this.closeSearch} />
          </div>
        </div>
      );
    }

    return (
      <div className="user-stickers-packs">
        <div className="flex-row">
          {this.renderStickerPacks(packsToDisplay)}

          <div className="sticker-list">{this.renderStickerList(packsToDisplay)}</div>

          <div
            className="user-stickers-packs__close"
            onClick={() => this.props.toggleStickers(false)}
          >
            X
          </div>
        </div>

        {this.state.dndSupported || (
          <div className="dnd-notice">
            <FontAwesome className="fa-exclamation-triangle" />
            &nbsp;Sorry, drag and drop is not supported on your device.
          </div>
        )}
      </div>
    );
  }
}

Stickers.propTypes = {
  tabOpen: propTypes.bool,
  getStickerPacks: propTypes.func,
  setActivePack: propTypes.func,
  activePack: propTypes.oneOfType([propTypes.number, propTypes.bool, propTypes.string]),
  packs: propTypes.oneOfType([propTypes.array, propTypes.bool]),
  toggleStickers: propTypes.func.isRequired,
};

export default Stickers;
